export class ObjectMap {

	getValue(rootObj: any, path: string): any {
		const tokens: string[] = path.split('.');
		let cursor: any = rootObj;

		for (let ps = 0; cursor && ps < tokens.length; ++ps) {
			cursor = cursor[tokens[ps]];
		}
		return cursor;
	}

	getNumber(json: any, path: string): number {
		let value: any = +this.getValue(json, path);
		if (isNaN(value)) {
			value = 0;
		}
		return value;
	}

	getBoolean(json: any, path: string): boolean {
		let boolValue = false;

		const value: any = this.getValue(json, path);

		if (typeof value === 'boolean') {
			boolValue = value;
		} else if (value && typeof value === 'string') {
			switch (value.toLowerCase()) {
				case 'true':
				case 't':
				case '1':
					boolValue = true;
					break;
			}
		}
		return boolValue;
	}

	getString(json: any, path: string): string | null {
		let stringValue: string | null = null;

		const value: any = this.getValue(json, path);
		if (value && typeof value === 'string') {
			stringValue = value;
		}
		return stringValue;
	}

	setValue(rootObj: any, path: string, newValue: any): void {
		if (path && path.length > 0) {
			const tokens: string[] = path.split('.');
			let cursor: any = rootObj;

			for (let ps = 0; cursor && ps < tokens.length - 1; ++ps) {
				cursor = cursor[tokens[ps]];
			}
			if (cursor) {
				cursor[tokens[tokens.length - 1]] = newValue;
			}
		}
	}
}
